<template>
    <div class="report__content loading" v-if="this.isAvailable === false">
        <div class="spinner spinner--running"></div>
    </div>
    <div class="report__content" v-else>
        <div class="wrapper">
            <h2 class="report__title">Konsultacja zgłoszenia <code>{{ this.caseId }}</code></h2>
        </div>
        <hr>
        <div class="wrapper">
            <div class="form__row">
                <h4 class="form__row-title">Kod oceny chirurgicznej</h4>
                <div class="form__col--full">
                    <select class="report-item__filter-field" v-model="consultationData.surgicalEvaluation.code">
                        <option :value="null">Brak</option>
                        <option :value="1">Możliwy zabieg</option>
                        <option :value="2">Ponowna ocena</option>
                        <option :value="3">Niemożliwy zabieg</option>
                        <option :value="4">Inna ocena</option>
                    </select>
                </div>
            </div>
            <div class="form__row">
                <div class="form__col--full">
                    <textarea rows="4" v-model="consultationData.surgicalEvaluation.note"></textarea>
                </div>
            </div>
            <div class="form__row">
                <h4 class="form__row-title">Przewidywana data zabiegu</h4>
                <div class="form__col--full">
                    <input type="date" class="form__field" v-model="consultationData.expectedSurgeryDate"/>
                </div>
            </div>
            <div class="form__row">
                <h4 class="form__row-title">Ocena skuteczności chemioterapii</h4>
                <div class="form__col--full">
                    <select class="report-item__filter-field" v-model="consultationData.chemotherapyEffectiveness">
                        <option :value="null">Brak</option>
                        <option :value="1">Odpowiedź biochemiczna nie potwierdzona obrazowo</option>
                        <option :value="2">Odpowiedź obrazowa</option>
                        <option :value="3">Stabilizacja</option>
                        <option :value="4">Progresja biochemiczna nie potwierdzona obrazowo</option>
                        <option :value="5">Progresja obrazowa</option>
                    </select>
                </div>
            </div>
            <div class="form__row">
                <h4 class="form__row-title">Data zakończenia ostatniego cyklu chemii</h4>
                <div class="form__col--full">
                    <input type="date" class="form__field" v-model="consultationData.lastChemotherapyCycleAt"/>
                </div>
            </div>
            <div class="form__row">
                <h4 class="form__row-title">Radykalność zabiegu</h4>
                <div class="form__col--full">
                    <select class="report-item__filter-field" v-model="consultationData.procedureRisk.code">
                        <option :value="null">Brak oceny</option>
                        <option :value="1">Radykalny R0</option>
                        <option :value="2">Inna ocena</option>
                    </select>
                </div>
            </div>
            <div class="form__row">
                <div class="form__col--full">
                    <textarea rows="4" v-model="consultationData.procedureRisk.note"></textarea>
                </div>
            </div>
        </div>
        <hr>
        <div class="wrapper">
            <div class="form__row form__row--center">
                <a @click="saveConsultation" class="btn">Zapisz</a>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import {mapGetters} from "vuex"

export default {
    name: "Summary",
    data() {
        return {
            isAvailable: false,
            caseId: '',
            consultationData: {
                surgicalEvaluation: {
                    code: null,
                    note: null,
                },
                expectedSurgeryDate: null,
                chemotherapyEffectiveness: null,
                lastChemotherapyCycleAt: null,
                procedureRisk: {
                    code: null,
                    note: null,
                },
            },
        }
    },
    computed: mapGetters({
        securedRequestHeader: "getSecuredRequestHeader",
    }),
    methods: {
        displayDate(fullDate) {
            const date = new Date(fullDate);
            return date.toLocaleString('pl-PL').split(',')[0]
        },
        saveConsultation() {
            const url = `${process.env.VUE_APP_API_URL}/medical-case/${this.$route.params.id}/consultation-data`;

            axios
                .put(url, this.consultationData, {
                    headers: this.securedRequestHeader,
                })
                .then(() => {
                    setTimeout(() => this.$router.push("/tabela-zgloszen"), 1000);
                })
        },
    },
    beforeMount() {
        axios
            .get(`${process.env.VUE_APP_API_URL}/medical-case/${this.$route.params.id}`, {
                headers: this.securedRequestHeader,
            })
            .then((response) => {
                this.uuid = response.data.id;
                this.caseId = response.data.shortId;
                if (response.data.consultationData !== null) {
                    this.consultationData = response.data.consultationData;
                }
                this.isAvailable = true;
            })
            .catch(() => {
                this.isAvailable = false;
            })
    }
}
</script>

<style lang="scss">
.report {
    &__id {
        font-family: 'Source Code Pro', sans-serif;
        text-align: center;
        background: #36BACA;
        border-radius: 50px;
        padding: 10px;
        margin-bottom: 30px;
        color: #fff;
    }
}

.patient {
    &__desc {
        text-align: center;
    }

    &__form {
        padding-bottom: 50px;
    }
}
</style>
